/* eslint-disable */
import { useEffect, useRef } from "react";

const AutoLogout = (timeout = 15 * 60 * 1000) => {
	const timerRef = useRef<NodeJS.Timeout | null>(null);

	const resetTimer = () => {
		if (timerRef.current) clearTimeout(timerRef.current);

		timerRef.current = setTimeout(() => {
			localStorage.clear();
			window.location.href = "/";
		}, timeout);
	};

	useEffect(() => {
		const events = ["mousemove", "keydown", "mousedown", "touchstart"];
		events.forEach((event) => window.addEventListener(event, resetTimer));

		resetTimer();

		return () => {
			if (timerRef.current) clearTimeout(timerRef.current);
			events.forEach((event) => window.removeEventListener(event, resetTimer));
		};
	}, [timeout]);
};

export default AutoLogout;
